/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { TablePagination, Box, Select, MenuItem, Typography, IconButton } from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import classes from './Pagination.module.scss';

const TablePaginationAction = ({ page, count, onPageChange, rowsPerPage, ...props }) => {
  const totalPageCount = useMemo(() => {
    return Math.ceil(count / rowsPerPage);
  }, [count, rowsPerPage]);
  return (
    <Box
      onClick={(event) => {
        event.stopPropagation();
      }}
      display='flex'
      alignItems='center'>
      <Box className={classes.goToPage} display='flex' alignItems='center'>
        <Typography variant='body2'>Page:</Typography>
        <Select
          disableUnderline
          value={page + 1}
          margin='none'
          onChange={(event) => {
            onPageChange(event.target.value - 1);
          }}>
          {Array.from({ length: totalPageCount }, (_, idx) => idx + 1).map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box className={classes.wrapperActions} display='flex' alignItems='center'>
        <Box className={classes.actions}>
          <IconButton
            onClick={() => {
              onPageChange(0);
            }}
            disabled={totalPageCount === 0 || page + 1 === 1}>
            <FirstPageIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              onPageChange(page - 1);
            }}
            disabled={page + 1 === 1}>
            <KeyboardArrowLeftIcon />
          </IconButton>
        </Box>
        <Box className={classes.actions}>
          <IconButton
            onClick={() => {
              onPageChange(page + 1);
            }}
            disabled={count === 0 || page + 1 === totalPageCount}>
            <KeyboardArrowRightIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              onPageChange(totalPageCount - 1);
            }}
            disabled={count === 0 || page + 1 === totalPageCount}>
            <LastPageIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};
const Pagination = ({
  pageSize = 10,
  pageSizeOptions = [10, 20, 25, 50, 100],
  current = 1,
  ref,
  total = 0,
  onChange,
}) => {
  const [currentPage, setCurrentPage] = React.useState(current);
  const [currentPageSize, setCurrentPageSize] = React.useState(pageSize);

  React.useEffect(() => {
    setCurrentPage(current);
  }, [current]);

  React.useEffect(() => {
    setCurrentPageSize(pageSize);
  }, [pageSize]);

  return (
    <TablePagination
      ref={ref}
      className={classes.pagination}
      ActionsComponent={TablePaginationAction}
      component='div'
      onPageChange={(nextPage) => {
        setCurrentPage(nextPage + 1);
        onChange(nextPage + 1, pageSize);
      }}
      onRowsPerPageChange={(event) => {
        setCurrentPageSize(event.target.value);
        onChange(current, event.target.value);
      }}
      rowsPerPageOptions={pageSizeOptions}
      rowsPerPage={currentPageSize}
      page={currentPage - 1}
      count={total}
    />
  );
};

export default Pagination;
